export default __webpack_public_path__ + "static/media/user_female_avatar.6857a11f.png";